var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavResourcesGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.6,
    height: 21.6,
    viewBox: "0 0 21.6 21.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    transform: "translate(-2.2 -2.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1106",
    "data-name": "Rectangle 1106",
    d: "M0-.8H8a.8.8,0,0,1,.8.8V8a.8.8,0,0,1-.8.8H0A.8.8,0,0,1-.8,8V0A.8.8,0,0,1,0-.8ZM7.2.8H.8V7.2H7.2Z",
    transform: "translate(3 2.864)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    d: "M0-.8H8a.8.8,0,0,1,.8.8V8a.8.8,0,0,1-.8.8H0A.8.8,0,0,1-.8,8V0A.8.8,0,0,1,0-.8ZM7.2.8H.8V7.2H7.2Z",
    transform: "translate(15 2.864)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    d: "M0-.8H8a.8.8,0,0,1,.8.8V8a.8.8,0,0,1-.8.8H0A.8.8,0,0,1-.8,8V0A.8.8,0,0,1,0-.8ZM7.2.8H.8V7.2H7.2Z",
    transform: "translate(15 14.864)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    d: "M0-.8H8a.8.8,0,0,1,.8.8V8a.8.8,0,0,1-.8.8H0A.8.8,0,0,1-.8,8V0A.8.8,0,0,1,0-.8ZM7.2.8H.8V7.2H7.2Z",
    transform: "translate(3 14.864)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavResourcesGrid);
export default __webpack_public_path__ + "static/media/Nav-ResourcesGrid.64d67fd176ad3493b0c852e1087b53bb.svg";
export { ForwardRef as ReactComponent };